import { Injectable } from '@angular/core'

import { BicService } from '@lemon/core/service/bic.service'
import { CodeCheckService } from '@lemon/core/service/code-check.service'
import { CurrencyFormatService } from '@lemon/core/service/currency-format.service'
import { CurrencyService } from '@lemon/core/service/currency.service'
import { DateService } from '@lemon/core/service/date.service'
import { IbanService } from '@lemon/core/service/iban.service'
import { StringService } from '@lemon/core/service/string.service'
import { TimestampProviderBase } from '@lemon/core/service/timestamp-provider.interface'
import { ViitenumeroService } from '@lemon/core/service/viitenumero.service'

import { AjastettuTyoService } from '@lemon/core-firebase/eraajot/ajastettu/ajastetut-tyot.service'
import { ApixUriService } from '@lemon/core-firebase/service/apix-uri.service'
import { AsiakasJaettuLemonaidService } from '@lemon/core-firebase/service/asiakas-jaettu-lemonaid.service'
import { BankBalancePublicUriService } from '@lemon/core-firebase/service/bank-balance-public-uri.service'
import { BankConsentUriService } from '@lemon/core-firebase/service/bank-consent-uri.service'
import { FirestoreIndeksoija } from '@lemon/core-firebase/service/firestore.indeksoija'
import { KayttoehdotUriService } from '@lemon/core-firebase/service/kayttoehdot-uri.service'
import { KopioijaPalvelu } from '@lemon/core-firebase/service/kopioija.service'
import { KycUriService } from '@lemon/core-firebase/service/kyc-uri.service'
import { LaskuKorkoService } from '@lemon/core-firebase/service/lasku/lasku-korko.service'
import { LaskuLahetyksenToistoService } from '@lemon/core-firebase/service/lasku/lasku-lahetyksen-toisto.service'
import { LaskuLahetystietojenLuoja } from '@lemon/core-firebase/service/lasku/lasku-lahetystietojen.luoja'
import { LaskuSharedService, ReskontraService } from '@lemon/core-firebase/service/lasku/lasku-shared.service'
import { LaskuSpostiService } from '@lemon/core-firebase/service/lasku/lasku-sposti.service'
import { LaskuUriService } from '@lemon/core-firebase/service/lasku/lasku-uri.service'
import { LaskuIndeksoija } from '@lemon/core-firebase/service/lasku/lasku.indeksoija'
import { LaskuKopioija } from '@lemon/core-firebase/service/lasku/lasku.kopioija'
import { SahkoisenLaskunValittajaService } from '@lemon/core-firebase/service/lasku/sahkoisen-laskun-valittaja.service'
import { ToimittajaTunnisteService } from '@lemon/core-firebase/service/lasku/toimittaja-tunniste.service'
import { LemonaidRaportitUriService } from '@lemon/core-firebase/service/lemonaid-raportit-uri.service'
import { MaksutService } from '@lemon/core-firebase/service/maksut.service'
import { LemonaidProjektitUriService } from '@lemon/core-firebase/service/projektit-uri.service'
import { PushIlmoitusUriService } from '@lemon/core-firebase/service/push-ilmoitus-uri.service'
import { TilinpaatosUriService } from '@lemon/core-firebase/service/tilinpaatos-uri.service'
import { TositeUriService } from '@lemon/core-firebase/service/tosite/tosite-uri.service'
import { TositeIndeksoija } from '@lemon/core-firebase/service/tosite/tosite.indeksoija'
import { TositeKopioija } from '@lemon/core-firebase/service/tosite/tosite.kopioija'
import { CountryLocalizationService, TranslationService } from '@lemon/core-firebase/service/translation.service'
import { VahvistettuKorkoService } from '@lemon/core-firebase/service/vahvistettu-korko.service'
import { VatNumberValidationService } from '@lemon/core-firebase/service/vat-number-validation.service'
import { PyhapaivatService } from '@lemon/core/service/pyhapaiva.service'
import { TimestampService } from './service/timestamp-service'

@Injectable()
export class AsiakasJaettuLemonaidServiceAngular extends AsiakasJaettuLemonaidService {
  constructor(dateService: DateService) {
    super(dateService)
  }
}

// Common
@Injectable()
export class BicServiceAngular extends BicService {
  constructor() {
    super()
  }
}
@Injectable()
export class CodeCheckServiceAngular extends CodeCheckService {
  constructor() {
    super()
  }
}
@Injectable()
export class IbanServiceAngular extends IbanService {
  constructor(bicServic: BicService) {
    super(bicServic)
  }
}
@Injectable()
export class ViitenumeroServiceAngular extends ViitenumeroService {
  constructor(ibanServic: IbanService, bicServic: BicService, stringServic: StringService, dateServic: DateService, currencyServic: CurrencyService) {
    super(ibanServic, bicServic, stringServic, dateServic, currencyServic)
  }
}
@Injectable()
export class CurrencyServiceAngular extends CurrencyService {
  constructor() {
    super(new CurrencyFormatService())
  }
}
@Injectable()
export class DateServiceAngular extends DateService {
  constructor() {
    super()
  }
}
@Injectable()
export class StringServiceAngular extends StringService {
  constructor() {
    super()
  }
}
@Injectable()
export class FirestoreIndeksoijaAngular extends FirestoreIndeksoija {
  constructor(dateServic: DateService) {
    super(dateServic)
  }
}
@Injectable()
export class KopioijaPalveluAngular extends KopioijaPalvelu {
  constructor(timestampProviderBas: TimestampProviderBase) {
    super(timestampProviderBas)
  }
}
@Injectable()
export class TranslationServiceAngular extends TranslationService {
  constructor() {
    super()
  }
}

@Injectable()
export class KayttoehdotUriServiceAngular extends KayttoehdotUriService {
  constructor() {
    super()
  }
}

@Injectable()
export class KycUriServiceAngular extends KycUriService {
  constructor() {
    super()
  }
}

// { provide: BicService, useClass: BicServiceAngular },
// { provide: IbanService, useClass: IbanServiceAngular },
// { provide: ViitenumeroService, useClass: ViitenumeroServiceAngular },
// { provide: CurrencyService, useClass: CurrencyServiceAngular },
// { provide: DateService, useClass: DateServiceAngular },
// { provide: FirestoreIndeksoija, useClass: FirestoreIndeksoijaAngular },
// { provide: KopioijaPalvelu, useClass: KopioijaPalveluAngular },
// { provide: CodeCheckService, useClass: CodeCheckServiceAngular },
// { provide: TranslationService, useClass: TranslationServiceAngular },
// { provide: StringService, useClass: StringServiceAngular },
// { provide: ViiaUriService, useClass: ViiaUriServiceAngular },

// Laskut
@Injectable()
export class VahvistettuKorkoServiceAngular extends VahvistettuKorkoService {
  constructor(dateServic: DateService) {
    super(dateServic)
  }
}
@Injectable()
export class LaskuKorkoServiceAngular extends LaskuKorkoService {
  constructor(dateServic: DateService, currencyServic: CurrencyService, reskontraServic: ReskontraService, vahvistettuKorkoServic: VahvistettuKorkoService, laskuSharedServic: LaskuSharedService) {
    super(dateServic, currencyServic, reskontraServic, vahvistettuKorkoServic, laskuSharedServic)
  }
}
@Injectable()
export class LaskuLahetyksenToistoServiceAngular extends LaskuLahetyksenToistoService {
  constructor(dateService: DateService) {
    super(dateService)
  }
}
@Injectable()
export class LaskuLahetystietojenLuojaAngular extends LaskuLahetystietojenLuoja {
  constructor(dateServic: DateService, currencyServic: CurrencyService, share: LaskuSharedService, timestampProvide: TimestampProviderBase) {
    super(dateServic, currencyServic, share, timestampProvide)
  }
}
@Injectable()
export class SahkoisenLaskunValittajaServiceAngular extends SahkoisenLaskunValittajaService {
  constructor() {
    super()
  }
}
@Injectable()
export class LaskuKopioijaAngular extends LaskuKopioija {
  constructor(
    dateServic: DateService,
    timestampServic: TimestampProviderBase,
    kopioijaPalvel: KopioijaPalvelu,
    share: LaskuSharedService,
    korkoServic: LaskuKorkoService,
    vahvistettuKorkoServic: VahvistettuKorkoService,
  ) {
    super(dateServic, timestampServic, kopioijaPalvel, share, korkoServic, vahvistettuKorkoServic)
  }
}
@Injectable()
export class LaskuIndeksoijaAngular extends LaskuIndeksoija {
  constructor(firestoreIndeksoij: FirestoreIndeksoija, sharedLaskuServic: LaskuSharedService, reskontraServic: ReskontraService, currencyServic: CurrencyService) {
    super(firestoreIndeksoij, sharedLaskuServic, reskontraServic, currencyServic)
  }
}
@Injectable()
export class LaskuUriServiceAngular extends LaskuUriService {
  constructor() {
    super()
  }
}
@Injectable()
export class LaskuSpostiServiceAngular extends LaskuSpostiService {
  constructor(share: LaskuSharedService, maaServic: CountryLocalizationService) {
    super(share, maaServic)
  }
}
@Injectable()
export class ReskontraServiceAngular extends ReskontraService {
  constructor(dateServic: DateService) {
    super(dateServic)
  }
}
@Injectable()
export class LaskuSharedServiceAngular extends LaskuSharedService {
  constructor(
    dateServic: DateService,
    translationServic: TranslationService,
    countryLocalizationServic: CountryLocalizationService,
    currencyServic: CurrencyService,
    reskontraServic: ReskontraService,
    timestampProvide: TimestampProviderBase,
    viitenumeroServic: ViitenumeroService,
    codeCheckService: CodeCheckService,
    stringService: StringService,
  ) {
    super(dateServic, translationServic, countryLocalizationServic, currencyServic, reskontraServic, timestampProvide, viitenumeroServic, codeCheckService, stringService)
  }
}
@Injectable()
export class BicAngularServiceAngular extends BicService {
  constructor() {
    super()
  }
}

// { provide: LaskuIndeksoija, useClass: LaskuIndeksoijaAngular },
// { provide: LaskuKopioija, useClass: LaskuKopioijaAngular },
// { provide: LaskuKorkoService, useClass: LaskuKorkoServiceAngular },
// { provide: LaskuSharedService, useClass: LaskuSharedServiceAngular },
// { provide: LaskuSpostiService, useClass: LaskuSpostiServiceAngular },
// { provide: LaskuUriService, useClass: LaskuUriServiceAngular },
// { provide: LaskuLahetystietojenLuoja, useClass: LaskuLahetystietojenLuojaAngular },
// { provide: ReskontraService, useClass: ReskontraServiceAngular },

// Tositteet
@Injectable()
export class TositeKopioijaAngular extends TositeKopioija {
  constructor(kopioijaPalvel: KopioijaPalvelu) {
    super(kopioijaPalvel)
  }
}
@Injectable()
export class TositeUriServiceAngular extends TositeUriService {
  constructor() {
    super()
  }
}
@Injectable()
export class TositeIndeksoijaAngular extends TositeIndeksoija {
  constructor(firestoreIndeksoij: FirestoreIndeksoija, currencyServic: CurrencyService, dateServic: DateService) {
    super(firestoreIndeksoij, currencyServic, dateServic)
  }
}
@Injectable()
export class TilinpaatosUriServiceAngular extends TilinpaatosUriService {
  constructor() {
    super()
  }
}

@Injectable()
export class AjastettuTyoServiceAngular extends AjastettuTyoService {
  constructor(dateService: DateService, timestampService: TimestampService, pyhapaivatService: PyhapaivatService) {
    super(dateService, timestampService, pyhapaivatService)
  }
}

@Injectable()
export class VatNumberValidationServiceAngular extends VatNumberValidationService {
  constructor() {
    super()
  }
}
@Injectable()
export class ToimittajaTunnisteServiceAngular extends ToimittajaTunnisteService {
  constructor(codeCheckService: CodeCheckService, vatNumberValidationService: VatNumberValidationService) {
    super(codeCheckService, vatNumberValidationService)
  }
}

@Injectable()
export class BankConsentUriServiceAngular extends BankConsentUriService {
  constructor() {
    super()
  }
}

@Injectable()
export class BankBalancePublicUriServiceAngular extends BankBalancePublicUriService {
  constructor() {
    super()
  }
}

@Injectable()
export class ApixUriServiceAngular extends ApixUriService {
  constructor() {
    super()
  }
}

@Injectable()
export class MaksutServiceAngular extends MaksutService {
  constructor(dateService: DateService) {
    super(dateService)
  }
}
@Injectable()
export class LemonaidRaportitUriServiceAngular extends LemonaidRaportitUriService {
  constructor() {
    super()
  }
}
@Injectable()
export class LemonaidProjektitUriServiceAngular extends LemonaidProjektitUriService {
  constructor() {
    super()
  }
}

@Injectable()
export class PushIlmoitusUriServiceAngular extends PushIlmoitusUriService {
  constructor() {
    super()
  }
}
